import {
  buildZellePaymentPayloadJson,
  normalizeZelleRecipientName,
  normalizeZelleToken,
} from "../utils/zellePayload";

export { normalizeZelleToken, normalizeZelleRecipientName };

/**
 * Build the same enroll.zellepay.com QR link Zelle uses when you share your QR code.
 * Payload: base64(JSON) with keys name, action, token; phones as digits-only.
 */
export function buildZelleQrUrl({ token, name }) {
  const json = buildZellePaymentPayloadJson({ token, name });
  if (!json) return "";

  let base64;
  try {
    if (typeof TextEncoder === "undefined" || typeof btoa !== "function") return "";
    const bytes = new TextEncoder().encode(json);
    let binary = "";
    bytes.forEach((b) => {
      binary += String.fromCharCode(b);
    });
    base64 = btoa(binary);
  } catch {
    return "";
  }

  return `https://enroll.zellepay.com/qr-codes?data=${encodeURIComponent(base64)}`;
}
